import { makeStyles } from '@material-ui/core';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles({
  grid: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainer: {
    position: 'fixed',
    bottom: '3%',
  },

  customerCartLogo: {
    width: '100%',
    maxWidth: '360px',
  },

  text: {
    color: ({ headingTextColor }: StateConfig) =>
      headingTextColor ? headingTextColor : themeColor.tangaroa,
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '3.427rem',
    fontFamily: 'Raleway',
    marginTop: '6.77vh',
  },

  trainingWatermarkContainer: {
    position: 'relative',
  },

  trainingModeBackground: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },

  themeBackground: {
    backgroundImage: ({ backgroundImageURL }: StateConfig) =>
      backgroundImageURL ? `url(${backgroundImageURL})` : '',
    backgroundColor: ({ backgroundColor }: StateConfig) =>
      backgroundColor ? backgroundColor : '#FFFFFF',
  },

  trainingWaterMark: {
    right: 0,
    '@media (min-width: 1024px)': {
      fontSize: '2.3rem',
    },
    '@media (min-width: 1280px)': {
      fontSize: '2.9rem',
    },
    '@media (min-width: 1366px)': {
      fontSize: '3.1rem',
    },
    '@media (min-width: 1600px)': {
      fontSize: '3.6rem',
    },
    '@media (min-width: 1920px)': {
      fontSize: '4.3rem',
    },
  },
  storeLogo: {
    height: '11vh',
    paddingLeft: '0.5vw',
  },
});
